import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Lets a page put a context pill next to its title in the top-bar breadcrumb (e.g. Build Referral
 * shows the selected doc type). The breadcrumb clears it on every navigation, so a page only has
 * to set it; clearing on destroy is still good manners for same-route re-renders.
 */
@Injectable({ providedIn: 'root' })
export class PageBreadcrumbService {
  private readonly badgeSubject = new BehaviorSubject<string | null>(null);
  readonly badge$ = this.badgeSubject.asObservable();

  setBadge(text: string | null): void {
    this.badgeSubject.next(text?.trim() || null);
  }

  clearBadge(): void {
    this.badgeSubject.next(null);
  }
}
